exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".redux-templates-import-button-group{text-align:center}.redux-templates-import-button-group.disabled span a{cursor:default;opacity:0.8}.redux-templates-single-section-item{margin-bottom:15px}.redux-templates-single-section-item .redux-templates-import-button-group{margin-top:10%}\n", ""]);

